import { render, staticRenderFns } from "./metadata.vue?vue&type=template&id=54753d6b&"
import script from "./metadata.vue?vue&type=script&lang=ts&"
export * from "./metadata.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports